<div class="notification-message-inline" [ngStyle]="{'border-left': '5px solid ' + getPhosphorClassAndColor().color, 'background-color': backgroundColor!}">
    <app-icon class="notification-message-icon"
        [phosphorClass]="getPhosphorClassAndColor().class"
        [color]="getPhosphorClassAndColor().color"
    ></app-icon>
    <p class="notification-message-text">
        {{ message }}
    </p>
</div>
